import {useQuery} from "@tanstack/react-query"
import {UNLIMITED_PAGE_SIZE} from "data/constants"
import {studentStaffContactsServiceV3} from "services"
import {StudentStaffContactRole} from "types/contacts"
import {BaseDepartmentId} from "types/departments"

const INITIAL_DATA = []

export const useAllEnrollmentSpecialists = () => {
    const query = useQuery(
        ["all-enrollment-specialists"],
        async () => {
            const {data} = await studentStaffContactsServiceV3.getStaffs({
                range: {pageSize: UNLIMITED_PAGE_SIZE, page: 1},
                filter: {
                    departmentId: BaseDepartmentId.Admissions,
                    studentStaffContactRoleId: StudentStaffContactRole.EnrollmentSpecialist
                }
            })
            return data
        },
        {}
    )
    return {enrollmentSpecialists: query.data ?? INITIAL_DATA, isLoading: query.isFetching}
}
